<script>
    import { key } from '../store';

    let providedKey;
    let invalidPwd = false;

    function login () {
        fetch(`${_app.env.API_URL}/login?key=${providedKey}`).then((res) => {
            if (res.status !== 200) invalidPwd = true;
            else key.set(providedKey);
        });
    }
</script>

<div class="login-container">
    <div>
        <h1>Stream!</h1>
        <p>Bienvenue sur Stream, le Netflix gratuit! Entrez le mot de passe pour accéder aux films!</p>

        <input placeholder="Super secret password" bind:value={providedKey} type="password" on:keyup={(e) => e.code === 'Enter' ? login() : null} />
        <button on:click={login}>Let's Stream</button>
        {#if invalidPwd}
            <div>
                <h3 class="invalid-pwd">Invalid password!</h3>
            </div>
        {/if}
    </div>
</div>

<style>
	h1 {
        text-align: center;
        color: #B33C86;
    }
    .login-container {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .invalid-pwd {
        color: red;
    }
</style>